import * as Msal from 'msal';

export default class AuthService {
  constructor(config) {
    //https://www.npmjs.com/package/msal
    this.applicationConfig = config;
    this.app = new Msal.UserAgentApplication(this.applicationConfig);
    this.app.handleRedirectCallback((error, response) => {
        // callback for login redirect
        if (!error && response && response.idToken && response.idToken.rawIdToken) {
          localStorage.idToken = response.idToken.rawIdToken;
        } else {
          delete localStorage.idToken;
        }
    });
  }
  login() {
    return this.app.loginRedirect(this.applicationConfig.graphScopes);
    /*.then(
      idToken => {        
        if (idToken.idToken) {
          return {
            uid: idToken.idToken.oid,
            mail: idToken.idToken.preferred_username,
            name: idToken.idToken.name,
            token: idToken.idToken.rawIdToken
          };
        } else {
          return null;
        }
      },
      () => {
        return null;
      }
    );*/
  }
  logout() {
    this.app.logout();
  }
  acquireToken() {
    return this.app.acquireTokenSilent(this.applicationConfig.graphScopes).then(
      accessToken => {
        return accessToken;
      },
      error => {
        console.log(error);
        return this.app
          .acquireTokenPopup(this.applicationConfig.graphScopes)
          .then(
            accessToken => {
              return accessToken;
            },
            err => {
              console.error(err);
            }
          );
      }
    );
  }
  //utils
  signIn() {
    return this.login();
  }
  signOut() {
    return this.logout();
  }
  isAuthenticated() {
    let acc = this.app.getAccount(); 
    return acc && acc.idToken && (new Date(acc.idToken.exp * 1000)) > (new Date());
  }
  getUserProfile() {
    let acc = this.app.getAccount(); 
    return {
      oid: acc.idToken.oid,
      unique_name: acc.idToken.preferred_username,
      name: acc.idToken.name
    };
  }
  getToken() {
    return localStorage.idToken;
  }
}
